/*
__/\\\\\\\\\\\\\\\__/\\\\\\\\\\\\\\\_____/\\\\\\\\\____        
 _\///////\\\/////__\///////\\\/////____/\\\\\\\\\\\\\__       
  _______\/\\\_____________\/\\\________/\\\/////////\\\_      
   _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_     
    _______\/\\\_____________\/\\\_______\/\\\\\\\\\\\\\\\_    
     _______\/\\\_____________\/\\\_______\/\\\/////////\\\_   
      _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_  
       _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_ 
        _______\///______________\///________\///________\///__
            
            COPYRIGHT TACTICAL TRANSPORTATION ADVISORS, INC. 
            ALL RIGHTS RESERVED.
*/

import { Document, Page, Image } from "@react-pdf/renderer";
import { formatEin, formatSsn } from "../../../../tools";
import moment from "moment";
import W42025Page1 from "../../../../../src/assets/W-4/2025/W-4-1.png";
import W42026Page1 from "../../../../../src/assets/W-4/2026/W-4-1.png";
import AbsoluteText from "../AbsoluteText";

export default function W4Pdf({ w4, signature }) {
  /// 2025
  const positions2025 = {
    has2Jobs: { x: 565, y: 380 },
    step3Children: { x: 411, y: 444 },
    step3OtherDependents: { x: 411, y: 462 },
    step3Total: { x: 512, y: 492 },
    step4OtherIncome: { x: 512, y: 528 },
    step4Deductions: { x: 512, y: 569 },
    step4ExtraWitholding: { x: 512, y: 592 },
    signature: { x: 108, y: 646 },
    date: { x: 464, y: 657 },
    employerName: { x: 105, y: 705 },
    employerAddress: { x: 105, y: 720 },
    firstDateOfEmployment: { x: 400, y: 720 },
    ein: { x: 480, y: 720 },
  };

  /// 2025
  const positions2026 = {
    has2Jobs: { x: 565, y: 396 },
    step3Children: { x: 411, y: 475 },
    step3OtherDependents: { x: 411, y: 487 },
    step3Total: { x: 512, y: 510 },
    step4OtherIncome: { x: 512, y: 546 },
    step4Deductions: { x: 512, y: 582 },
    step4ExtraWitholding: { x: 512, y: 598 },
    claimExemption: { x: 565, y: 644 },
    signature: { x: 108, y: 666 },
    date: { x: 464, y: 677 },
    employerName: { x: 105, y: 718 },
    employerAddress: { x: 105, y: 733 },
    firstDateOfEmployment: { x: 400, y: 733 },
    ein: { x: 480, y: 733 },
  };

  const positions = w4.year === 2025 ? positions2025 : positions2026;
  const pages = {
    one: w4.year === 2025 ? W42025Page1 : W42026Page1,
  };

  return (
    <Document>
      <Page size="LETTER" style={{ fontSize: 10 }}>
        <Image src={pages.one} />
        <AbsoluteText y={92} x={100} text={w4.firstNameMiddleInitial} />
        <AbsoluteText y={92} x={280} text={w4.lastName} />
        <AbsoluteText y={92} x={480} text={formatSsn(w4.ssn ?? "")} />
        <AbsoluteText y={116} x={100} text={w4.address} />
        <AbsoluteText y={140} x={100} text={w4.cityStateZip} />
        <AbsoluteText y={154 + (w4.filingStatus ?? 0) * 11.5} x={116} text="X" />
        <AbsoluteText {...positions.has2Jobs} text={w4.has2Jobs ? "X" : ""} />

        <AbsoluteText {...positions.step3Children} text={w4.step3Children.toLocaleString()} />
        <AbsoluteText {...positions.step3OtherDependents} text={w4.step3OtherDependents.toLocaleString()} />
        <AbsoluteText {...positions.step3Total} text={w4.step3Total.toLocaleString()} />
        <AbsoluteText {...positions.step4OtherIncome} text={w4.step4OtherIncome.toLocaleString()} />
        <AbsoluteText {...positions.step4Deductions} text={w4.step4Deductions.toLocaleString()} />
        <AbsoluteText {...positions.step4ExtraWitholding} text={w4.step4ExtraWitholding?.toLocaleString()} />

        {w4.claimExemption && <AbsoluteText y={644} x={564.5} text={w4.claimExemption ? "X" : ""} />}

        <Image src={signature.image} style={{ position: "absolute", top: positions.signature.y, left: positions.signature.x, width: 74, height: 25 }} />
        <AbsoluteText {...positions.date} text={moment().format("MM/DD/YYYY")} />

        <AbsoluteText {...positions.employerName} text={w4.employerName} />
        <AbsoluteText {...positions.employerAddress} text={w4.employerAddress} />
        <AbsoluteText {...positions.firstDateOfEmployment} text={w4.firstDateOfEmployment ? moment(w4.firstDateOfEmployment).format("MM/DD/YYYY") : ""} />
        <AbsoluteText {...positions.ein} text={formatEin(w4.ein)} />
      </Page>
    </Document>
  );
}
